module.exports = __webpack_public_path__ + "img/mint_booster_nft_button.9ece1f43.png";